/* CAPIVO ™ — shared behaviour: CTA scroll to quantity selector, carousels, exclusive accordions, autoplay videos */
(function(){
  if (window.__cpvInit) return; window.__cpvInit = true;
  var SEL = ['[data-cpv-qty]','.quantity-breaks-container','#cpv-buy','.quantity-break','[id^="Quantity-Form-"]','quantity-input','variant-selects','variant-radios','.product-form__input','.product-form'];
  function mainSection(){
    return document.querySelector('[id^="shopify-section-"][id$="__main"]') || document.querySelector('.product.grid, product-info, .product');
  }
  function target(){
    var root = mainSection() || document;
    for (var i=0;i<SEL.length;i++){ var el = root.querySelector(SEL[i]) || document.querySelector(SEL[i]); if (el && el.offsetParent !== null) return el; }
    return mainSection();
  }
  function headerOffset(){
    var h = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header, header');
    var v = h ? h.getBoundingClientRect().height : 0; if (!v || v > 90) v = 90; return v + 12;
  }
  function animateTo(y){
    var start = window.pageYOffset, dist = y - start, dur = 650, t0 = null, done = false;
    function ease(t){ return t<.5 ? 4*t*t*t : 1-Math.pow(-2*t+2,3)/2; }
    function step(ts){ if (t0===null) t0 = ts; var p = Math.min(1,(ts-t0)/dur); window.scrollTo(0, start + dist*ease(p)); if (p<1) requestAnimationFrame(step); else done = true; }
    requestAnimationFrame(step);
    setTimeout(function(){ if(!done) window.scrollTo(0,y); }, dur+250);
  }
  function go(){
    var main = mainSection(), el = target(); if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    animateTo(Math.max(0,y));
    setTimeout(function(){ el.classList.remove('cpv-flash'); void el.offsetWidth; el.classList.add('cpv-flash'); }, 700);
  }
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('[data-cpv-scroll], .cpv-cta');
    if (!a) return; e.preventDefault(); go();
  }, true);
  window.cpvScrollToBuy = go;

  function initCarousels(scope){
    (scope||document).querySelectorAll('[data-cpv-carousel]').forEach(function(c){
      if (c.__cpv) return; c.__cpv = true;
      var track = c.querySelector('.cpv-track'); if (!track) return;
      function by(dir){ var s = track.querySelector('.cpv-slide'); var gap = parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap)||0; var w = s ? s.getBoundingClientRect().width + gap : track.clientWidth*.8;
        var max = track.scrollWidth - track.clientWidth;
        var nx = track.scrollLeft + dir*w;
        if (dir>0 && track.scrollLeft >= max-4) nx = 0; else if (dir<0 && track.scrollLeft <= 4) nx = max;
        track.scrollTo({left:nx, behavior:'smooth'}); setTimeout(function(){ if (Math.abs(track.scrollLeft-nx)>w/2) track.scrollLeft = nx; }, 450); }
      c.querySelectorAll('[data-cpv-prev]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); by(-1); }); });
      c.querySelectorAll('[data-cpv-next]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); by(1); }); });
      // optional thumbnails: [data-cpv-thumb="index"]
      c.parentNode && c.parentNode.querySelectorAll('[data-cpv-thumb]').forEach(function(t){ t.addEventListener('click', function(){ var i = +t.getAttribute('data-cpv-thumb'); var s = track.querySelectorAll('.cpv-slide')[i]; if (s) track.scrollTo({left:s.offsetLeft - track.offsetLeft, behavior:'smooth'}); }); });
    });
  }
  function initAccordions(scope){
    (scope||document).querySelectorAll('[data-cpv-accordion]').forEach(function(g){
      if (g.__cpv) return; g.__cpv = true;
      g.querySelectorAll('details').forEach(function(d){ d.addEventListener('toggle', function(){ if (d.open) g.querySelectorAll('details').forEach(function(o){ if (o!==d && o.parentNode.closest('[data-cpv-accordion]')===g) o.open = false; }); }); });
    });
  }
  function initVideos(scope){
    var vids = (scope||document).querySelectorAll('video[data-cpv-autoplay]');
    vids.forEach(function(v){ v.muted = true; v.setAttribute('muted',''); v.removeAttribute('loading'); });
    if (!('IntersectionObserver' in window)) { vids.forEach(function(v){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); }); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(en){ var v = en.target; if (en.isIntersecting){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); } else { v.pause(); } }); }, {threshold:.25});
    vids.forEach(function(v){ io.observe(v); });
  }
  function init(scope){ initCarousels(scope); initAccordions(scope); initVideos(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); }); else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
